import React from 'react';
import {useFormContext} from 'react-hook-form';

const FormField = ({
  name,
  label,
  placeholder = '',
  type = 'text',
  disabled = false,
  validate = {},
  errorMessage,
  helpMessage,
  onChange,
  onInput,
  className = '',
  ...rest
}) => {
  const {
    register,
    formState: {errors},
  } = useFormContext();

  const registerProps = register(name, validate);

  return (
    <div className="form-group">
      {label && <label htmlFor={name}>{label}</label>}

      <input
        id={name}
        type={type}
        placeholder={placeholder}
        disabled={disabled}
        className={`form-control ${className} ${errors[name] ? 'is-invalid' : ''}`}
        {...registerProps}
        {...rest}
        onChange={(e) => {
          registerProps.onChange(e); // RHF intern
          if (onChange) onChange(e); // extern
        }}
        onInput={(e) => {
          if (onInput) onInput(e);
        }}
      />

      {helpMessage && <small className="form-text text-muted">{helpMessage}</small>}
      {errors[name] && (
        <div className="invalid-feedback">{errorMessage || errors[name]?.message}</div>
      )}
    </div>
  );
};

export default FormField;
